import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageOutlined, ProfileOutlined, ReconciliationOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Col, message, Tooltip } from 'antd';
import NewOrder from 'components/SalesOrders/NewOrder';
import { observer } from 'mobx-react';
import UserStore from 'stores/UserStore';
import { isSmartPhoneBrowser } from 'common/responsive';

const USER_NOT_VERIFIED_MESSAGE = 'We have sent a verification email, please verify it to continue.';

const Footer = () => {
    const [showOrder, setShowOrder] = useState(false);
    const history = useHistory();

    const handleNewQuoteClick = () => {
        if (!UserStore.isVerified) {
            message.warning(USER_NOT_VERIFIED_MESSAGE, 1);
            return;
        }
        history.push('/my-account/quotes/new-quote');
    };

    const handleNewOrderClick = () => {
        if (!UserStore.isVerified) {
            message.warning(USER_NOT_VERIFIED_MESSAGE, 1);
            return;
        }
        setShowOrder(true);
    };

    return (
        <div className="fixed z-10 bottom-0 right-0" style={{ boxShadow: '0 0 25px rgba(0,0,0,0.2)' }}>
            {showOrder && <NewOrder onClose={() => setShowOrder(false)} />}
            <Button.Group style={{ width: '100%' }}>
                <Col span={6}>
                    <Tooltip placement="top" title={'New Quote'}>
                        <Button onClick={handleNewQuoteClick} className="h-10 w-12" block>
                            <ProfileOutlined style={{ fontSize: '18px' }} />
                        </Button>
                    </Tooltip>
                </Col>
                {!isSmartPhoneBrowser() && (
                    <Col span={6}>
                        <Tooltip placement="top" title={'New Order'}>
                            <Button onClick={handleNewOrderClick} className="h-10 w-12" block>
                                <ReconciliationOutlined style={{ fontSize: '18px' }} />
                            </Button>
                        </Tooltip>
                    </Col>
                )}
                <Col span={6}>
                    <Tooltip placement="top" title={'Support'}>
                        <Button onClick={() => history.push('/my-account/support')} className="h-10 w-12" block>
                            <MessageOutlined style={{ fontSize: '18px' }} />
                        </Button>
                    </Tooltip>
                </Col>
                <Col span={6}>
                    <Tooltip placement="top" title={'Order Requirements'}>
                        <Button
                            onClick={() => history.push('/my-account/settings/order-requirements')}
                            className="h-10 w-12"
                            block
                        >
                            <SettingOutlined style={{ fontSize: '18px' }} />
                        </Button>
                    </Tooltip>
                </Col>
            </Button.Group>
        </div>
    );
};

export default observer(Footer);
